.price {
  margin: 0;
  font-size: 1.125rem;
  line-height: 30px;
  display: inline-flex;
  color: #333333;
}

@media screen and (max-width: 979px) {
  .price {
    font-size: 1rem;
    font-style: normal;
    font-weight: 700;
    line-height: 20px;
  }
}

.price--mobile {
  font-size: 1.125rem;
}

@media screen and (min-width: 980px) {
  .product-card.grid-view .price {
    font-size: 18px;
  }

  .product-card.list-view .price {
    font-size: 20px;
  }
}

:host(:not([dir="rtl"])) .currency {
  margin-left: 6px;
  margin-right: 9px;
}

:host([dir="rtl"]) .currency {
  margin-right: 6px;
  margin-left: 9px;
}